// VideoModal.jsx
import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css"; // Import Video.js styles
import { Loader } from "./Loader";

const VideoModal = ({ videoSrc, isOpen, onCancel, isLoading }) => {
  const videoRef = useRef(null); // Ref for the video element
  const playerRef = useRef(null); // Ref for the video player

  // Initialize the Video.js player when modal opens
  useEffect(() => {
    if (isOpen && videoRef.current) {
      const player = videojs(videoRef.current, {
        controls: true,
        autoplay: true,
        preload: "auto",
        controlBar: {
          fullscreenToggle: true,
          pictureInPictureToggle: true,
          playToggle: true,
          volumePanel: false,
          downloadButton: false, // Disable download button
        },
      });

      playerRef.current = player;

      // Disable right-click context menu
      videoRef.current.addEventListener("contextmenu", (e) =>
        e.preventDefault()
      );

      return () => {
        player.dispose(); // Clean up the player when component is unmounted or modal closes
      };
    }
  }, [isOpen, videoSrc]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Modal Background */}
      <div
        className="fixed inset-0 bg-gray-900 bg-opacity-50"
        onClick={onCancel}
      ></div>

      {/* Modal Content */}
      <div className="relative w-full max-w-[90%] p-6 bg-white rounded-lg shadow-lg">
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-gray-800">
            Live Class Recording
          </h3>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onCancel}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body (Video Player) */}
        {isLoading ? (
          <Loader />
        ) : (
          <div className="modal-body mb-6">
            <div className="w-full h-[65vh] flex justify-center items-center">
              <video
                ref={videoRef}
                className="video-js vjs-default-skin w-full h-full"
                controls
                preload="auto"
              >
                <source src={videoSrc} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoModal;
